/*
 * @Author: wjw
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-20 18:10:14
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-13 17:43:30
 */
/**
 * 时间戳转换
 */
const timestr = (number, type) => {
  if (!number) return "";
  let date = new Date(number * 1000);
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  let time = type == "year" ? Y + M + D : M + D;
  return time;
};

/**
 * 时间戳转换
 */
const ca_timestr = (number, type) => {
  if (!number) return "";
  let date = new Date(number * 1000);
  let Y = date.getFullYear() + "年";
  let M = date.getMonth() + 1 + "月";
  let D = date.getDate() + "日";
  let time = type == "year" ? Y + M + D : M + D;
  return time;
};

const HomeNavFilter = currentPath1 => {
  if (currentPath1 === "about") {
    return 2;
  }
  if (currentPath1 === "news") {
    return 3;
  }
  if (currentPath1 === "policy_building") {
    return 4;
  }
  if (currentPath1 === "old_age_education") {
    return 5;
  }
  if (currentPath1 === "special_report") {
    return 6;
  }
  if (currentPath1 === "information_open") {
    return 7;
  }
  if (currentPath1 === "wslndx") {
    return 8;
  }
  if (currentPath1 === "online_service") {
    return 9;
  }
};

const filmFilter = film => {
  let minute =
    Math.floor(film / 60) < 10
      ? "0" + Math.floor(film / 60)
      : Math.floor(film / 60);
  let second = ((film % 60) / 100).toFixed(2).slice(-2);
  return `${minute}:${second}`;
};

export default {
  timestr,
  ca_timestr,
  filmFilter,
  HomeNavFilter
};



// WEBPACK FOOTER //
// ./src/util/filter.js